import React from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../AppContext";

const OPZIONI = [
  {
    percorso: "/distinta-base",
    chiaveModulo: "diba",
    codice: "MOD-01",
    titolo: "Import Distinte Basi",
    descrizione: "Mappa il file del cliente sul tracciato di import distinta base e genera il file pronto per l'ERP.",
    icona: "🧾",
    stato: "operativo",
  },
  {
    percorso: "/ordini",
    chiaveModulo: "ordini",
    codice: "MOD-02",
    titolo: "Import Ordini",
    descrizione: "Mappa il file ordini del cliente e importa direttamente sull'ERP.",
    icona: "📦",
    stato: "operativo",
  },
  {
    percorso: "/ddt",
    chiaveModulo: "ddt",
    codice: "MOD-03",
    titolo: "Import DDT",
    descrizione: "Mappa il file del cliente sul tracciato di import DDT materiali e genera il file pronto per l'ERP.",
    icona: "🚚",
    stato: "operativo",
  },
];

export default function Scelta() {
  const navigate = useNavigate();
  const { moduliAttivi } = useApp();

  // "moduliAttivi === null" (risposta non ancora arrivata dal backend):
  // mostra tutte le card invece di farle comparire/sparire con uno
  // sfarfallio appena dopo il login.
  const opzioniVisibili = moduliAttivi
    ? OPZIONI.filter((opz) => moduliAttivi[opz.chiaveModulo] !== false)
    : OPZIONI;

  return (
    <div className="pagina">
      {/* Niente ".riquadro" qui: a differenza delle altre pagine, le card
          stanno direttamente sullo sfondo dell'app (non dentro un
          contenitore bianco che le raggruppa tutte) — così si vede lo
          sfondo anche qui, non solo intorno al contenuto. */}
      <section className="scelta-sezione">
        <h2 className="scelta-titolo-pagina">Cosa vuoi importare?</h2>
        <div className="scelta-card-griglia">
          {opzioniVisibili.map((opz) => (
            <button
              key={opz.percorso}
              className={`scelta-card scelta-card--${opz.chiaveModulo}`}
              onClick={() => navigate(opz.percorso)}
            >
              <div className="scelta-card-icona-cerchio">
                <span className="scelta-card-icona">{opz.icona}</span>
              </div>
              <span className="scelta-card-titolo">{opz.titolo}</span>
              <div className={`scelta-card-stato scelta-card-stato--${opz.stato}`}>
                <span className="scelta-card-stato-pallino" />
                {opz.stato === "operativo" ? "Operativo" : "In sviluppo"}
              </div>
            </button>
          ))}
        </div>
        {opzioniVisibili.length === 0 && (
          <p className="testo-secondario">
            Nessun modulo attivo: abilitane almeno uno da Impostazioni (☰ in alto a sinistra).
          </p>
        )}
      </section>
    </div>
  );
}
